import { TipoIntervaloRepeticaoEnum } from "core/features/manutencao/typings";

export function getStringIntervaloForTipoIntervalorRepeticao(
  tipoIntervaloRpeticaoId: TipoIntervaloRepeticaoEnum | undefined
) {
  switch (tipoIntervaloRpeticaoId) {
    case TipoIntervaloRepeticaoEnum.Diaria:
      return "dias";
    case TipoIntervaloRepeticaoEnum.Mensal:
      return "meses";
    case TipoIntervaloRepeticaoEnum.Semanal:
      return "semanas";
    case TipoIntervaloRepeticaoEnum.Anual:
      return "anos";
    default:
      return "";
  }
}
